import React from 'react';
import { Zap, Globe, Users, DollarSign, Award, Cpu } from 'lucide-react';
import Lab from '../images/AI-Trainer-Lab.jpg';

const AITrainerKitSection = () => {
  const features = [
    {
      icon: <Cpu className="w-6 h-6" />,
      title: "Intel-Powered Technology",
      description: "Advanced AI processing capabilities with industry-leading Intel technology for superior performance."
    },
    {
      icon: <Zap className="w-6 h-6" />,
      title: "Plug & Play Setup",
      description: "Ready to use out of the box. No complex installations or technical expertise required."
    },
    {
      icon: <Globe className="w-6 h-6" />,
      title: "Global Standards",
      description: "Aligned with NEP 2020, CSTA, UNESCO, and 21st Century Skills frameworks worldwide."
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "All Skill Levels",
      description: "From beginners to advanced learners - scalable learning paths for everyone."
    },
    {
      icon: <DollarSign className="w-6 h-6" />,
      title: "10x More Affordable",
      description: "Complete AI lab experience at a fraction of traditional costs without compromising quality."
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: "Industry Exposure",
      description: "Internship opportunities and industry visits to top innovation hubs globally."
    }
  ];

  return (
    <div style={{
      backgroundColor: '#0a0a0a',
      color: '#ffffff',
      padding: '4rem 2rem',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Main Layout Container */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '3rem',
          '@media (max-width: 768px)': {
            flexDirection: 'column',
            gap: '2rem'
          }
        }} className="responsive-container">
          
          {/* Left Side - Image */}
          <div style={{
            flex: '1',
            minHeight: '400px',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden'
          }} className="image-container">
            <img src={Lab} alt="AI Trainer Kit" style={{
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '20px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
            }} />
          </div>

          {/* Right Side - Content */}
          <div style={{
            flex: '1.2'
          }}>
            {/* Header */}
            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{
                fontSize: '2.5rem',
                fontWeight: '700',
                margin: '0 0 1.5rem 0',
                lineHeight: '1.2'
              }}>
                Why Choose the <span style={{ color: '#6366f1' }}>AI Trainer Kit</span>?
              </h2>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#a1a1aa',
                margin: '0'
              }}>
                Built with global educational standards in mind, aligned with key frameworks such as 
                India's NEP 2020, UNESCO's Future of Education initiative, and U.S. K-12 Computer 
                Science Standards.
              </p>
            </div>

            {/* Features Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '1.5rem'
            }}>
              {features.map((feature, index) => (
                <div key={index} style={{
                  backgroundColor: '#1a1a1a',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid #2a2a2a',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }} 
                className="feature-card"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#252525';
                  e.currentTarget.style.borderColor = '#6366f1';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.borderColor = '#2a2a2a';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <div style={{
                    backgroundColor: '#6366f1',
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1rem',
                    color: '#ffffff'
                  }}>
                    {feature.icon}
                  </div>
                  <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    margin: '0 0 0.75rem 0',
                    color: '#ffffff'
                  }}>
                    {feature.title}
                  </h3>
                  <p style={{
                    fontSize: '0.95rem',
                    lineHeight: '1.5',
                    color: '#a1a1aa',
                    margin: '0'
                  }}>
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Responsive Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .responsive-container {
            flex-direction: column !important;
            gap: 2rem !important;
          }
          
          .image-container {
            min-height: 300px !important;
            width: 100% !important;
          }
          
          h2 {
            font-size: 2rem !important;
            text-align: center;
          }
          
          .feature-card {
            min-width: auto !important;
          }
        }
        
        @media (max-width: 480px) {
          .responsive-container {
            padding: 0 1rem;
          }
          
          h2 {
            font-size: 1.75rem !important;
          }
          
          .feature-card {
            padding: 1.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AITrainerKitSection;